import {BaseComparator, Result, ResultState} from './BaseComparator';

type PlayerPosition = string

class PositionComparator implements BaseComparator<PlayerPosition> {
    constructor(private positions: any) {

    }

    compare(guess: PlayerPosition, actual: PlayerPosition): Result {
        if (guess === actual) {
            return {state: ResultState.MATCH};
        } else {
            if (this.positions[guess]["category"] === this.positions[actual]["category"]) {
                return {state: ResultState.CLOSE};
            } else {
                return {state: ResultState.FAR};
            }
        }
    }
}

export {PositionComparator};
export type {PlayerPosition};
